import { Box } from "@mui/material";
import useColors from "../../../../../api/hooks/useColors";
import { ComplexEntityTypes } from "../../../../../utils/constants";
import EndpointChart from "./hostChart/EndpointChart";

const EntityChartView = ({
  entityType,
  entities,
  appliedFilters,
  setAppliedFilters,
}) => {
  const colors = useColors();

  if (entityType === ComplexEntityTypes.HOST) {
    return (
      <Box
        sx={{
          boxShadow: "0px 0px 2px 1px " + colors.card_chart_box_shadow,
          borderRadius: "8px",
        }}
      >
        <EndpointChart
          entities={entities}
          appliedFilters={appliedFilters}
          setAppliedFilters={setAppliedFilters}
        />
      </Box>
    );
  } else return null;
};

export default EntityChartView;
